import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useFilterDialogStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            marginTop: theme.spacing(8),
            padding: theme.spacing(2),
        },
        appltFilters: {
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            padding: theme.spacing(6),
        },
        applyButton: {
            width: '100%',
        },
    })
);

export default useFilterDialogStyles;
